import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  UserActivitiesDocument,
  UserActivitiesQuery,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { Table } from '@otp/ui';
import { getTableConfig } from './config';

type UsersHistoryTableProps = {
  userIds: string[];
};

const PAGINATION_LIMIT = 10;

export const UsersHistoryTable = ({ userIds }: UsersHistoryTableProps) => {
  const { t } = useTranslation();

  const { page, setPage } = useTable();

  const { loading, data } = useQuery<UserActivitiesQuery>(
    UserActivitiesDocument,
    {
      variables: {
        filter: {
          userIds,
        },
        pagination: {
          limit: PAGINATION_LIMIT,
          offset: page * PAGINATION_LIMIT,
        },
      },
    },
  );

  const totalCount = data?.userActivities?.pagination?.totalCount;
  const userActivities = data?.userActivities?.records || [];

  const tableConfig = getTableConfig(userActivities, { t });

  return (
    <div>
      <Table
        data={userActivities}
        loading={loading}
        columns={tableConfig}
        options={{
          page,
          count: totalCount,
          rowsPerPage: PAGINATION_LIMIT,
          onChangePage: setPage,
        }}
      />
    </div>
  );
};
